module.exports = __webpack_public_path__ + "assets/Chi.3771559248d3da4074099e6ec0b9ec22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Chi.png
// module id = 782
// module chunks = 0